import React, { useState } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import styles from '../Inference.module.css';

export default ({ children, ...otherProps }) => {
  const [mouseOver, changeMouseOver] = useState(false);
  return (
    <div
      className={styles.preventScroll}
      {...otherProps}
      onMouseEnter={(e) => changeMouseOver(true)}
      onMouseLeave={(e) => changeMouseOver(false)}
    >
      <RemoveScroll enabled={mouseOver} removeScrollBar={false}>
        {children}
      </RemoveScroll>
    </div>
  );
};
